import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { MultiFactorAuthenticationRequest } from '../../requests/user/multi-factor-authentication.request';

@Injectable({
  providedIn: 'root'
})
export class SendMultiFactorAuthenticationService extends CommonService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  public sendToken(request: MultiFactorAuthenticationRequest): Observable<ReturnStruct> {
    return this.httpClient.post<ReturnStruct>(environment.urlApiOrchestratorUser + `SendMultiFactorAuthentication`, request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}